<template>
  <!-- prettier-ignore -->
  <div
    class="header"
    :class="{'header--interactive': isInteractive}">
    <ovp-person-tabs
      v-if="(persons.length > 0 && isInteractive) || !isInteractive"
      :person-id="personId"
      :persons="persons"
      @open="open()"
      @select="$personId => $emit('select', $personId)"
    />

    <template v-if="isInteractive">
      <ovp-screen class="header-screen">
        <ovp-typography
          class="header__title"
          type="body02"
          v-text="$t('screen.priceWidget.widget.empty.description')"
        />

        <ovp-screen-contract
          ref="contract"
          class="header-contract"
          :source="source"
          theme="dark"
          @cancel="cancel"
          @submit="submit"
        />
      </ovp-screen>
    </template>

    <ovp-modal
      v-model="show"
      x-only>
      <ovp-screen>
        <ovp-screen-contract
          ref="contract"
          class="header-contract"
          :source="source"
          theme="dark"
          @cancel="cancel"
          @submit="submit"
        />
      </ovp-screen>
    </ovp-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import OvpPersonTabs from '@/modules/PriceWidget/components/Header/Tabs'

import OvpModal from '@/components/Modal/Modal'
import OvpScreenContract from '@/components/Screen/Contract'
import OvpScreen from '@/components/Container/Screen'

import { LogHelper } from '@/helpers'

export default {
  name: 'Header',

  components: {
    OvpModal,
    OvpScreenContract,
    OvpScreen,
    OvpPersonTabs,
  },

  props: {
    personId: {
      type: String,
      default: '',
    },

    persons: {
      type: Array,
      required: true,
    },

    source: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      loading: false,
      show: false,
    }
  },

  computed: {
    ...mapState(['basket']),

    isInteractive() {
      return this.persons.length === 0
      // return this.$abConfig.get('isPriceWidgetFormInteractive') && this.persons.length === 0
    },
  },

  methods: {
    cancel() {
      this.show = false
    },

    open() {
      this.$emit('open')

      let tries = 0
      const _open = () => {
        tries++
        if (this.basket.basketId) {
          this.show = true
        } else if (tries < 10) {
          window.setTimeout(() => _open(), 500)
        } else {
          LogHelper.error('failed to open modal')
        }
      }

      _open()
    },

    submit() {
      this.cancel()
    },
  },
}
</script>

<style name="mobile" scoped>
.header {
  background-color: var(--c-white);

  &-contract {
    padding: 30px 20px 20px 20px;
  }

  &--interactive {
    .header-contract {
      padding: 0 20px;
    }

    .header__title {
      padding: 16px 24px 0 24px;
    }
  }
}
</style>

<style name="desktop" scoped>
@media (--md) {
  .header {
    background-color: transparent;

    &--interactive {
      background-color: var(--c-white);
    }

    &-screen >>> .screen-content {
      min-width: initial;
      max-width: initial;
      width: 100%;
    }

    & >>> .contract-date__date,
    & >>> .zipchooser {
      width: 350px;
    }

    & >>> .person-group {
      grid-template-columns: 165px 165px 165px 50px;

      .person__gender {
        .gender-item__text {
          font-size: 14px;
        }
      }
    }
  }
}
</style>
